import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../views/Home/Home'

Vue.use(VueRouter)

var router = new VueRouter({
    routes: [{
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            component: Home
        }, {
            path: '/story',
            name: 'story',
            component: () =>
                import ('@/views/story/Story')
        },
        {
            path: '/explore',
            component: () =>
                import ('@/views/explore')
        },
        {
            path: '/together-expedition',
            component: () =>
                import ('@/views/togetherExpedition')
        },
        {
            path: '/shareadv',
            component: () =>
                import ('@/views/shareadv')
        },

    ],
})

// 经验证，这个路由守卫没什么用，因为vue-router在跳转的路径相同的时候，在执行这个路由守卫之前就拦截了
router.beforeEach((to, from, next) => {
    // console.log(to.path===from.path)
    if (to.path === from.path) {

    } else {
        next()
    }
})

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js